export default "__VITE_ASSET__Bpa9AUuz__"